import React from 'react';

const AnimatedBoletoIcon = ({ className = 'w-20 h-20' }) => {
    return (
        <svg
            className={`${className} text-primary`}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <style>
                {`
                    @keyframes printBoleto {
                        0% { transform: translateY(30px); opacity: 0; }
                        20% { opacity: 1; }
                        100% { transform: translateY(0px); opacity: 1; }
                    }
                    @keyframes drawBarcode {
                        0% { transform: scaleY(0); transform-origin: top; }
                        100% { transform: scaleY(1); transform-origin: top; }
                    }
                    @keyframes floatPulse {
                        0%, 100% { transform: translateY(0px); }
                        50% { transform: translateY(-3px); }
                    }
                    .animate-print {
                        animation: printBoleto 1.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                    }
                    .animate-barcode {
                        animation: drawBarcode 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                        animation-delay: 0.5s;
                    }
                    .animate-float {
                        animation: floatPulse 3s ease-in-out infinite;
                        animation-delay: 1.2s; /* start floating after print */
                    }
                `}
            </style>
            
            {/* Background printer slot / device */}
            <path
                d="M15 60 C15 55, 20 50, 25 50 L75 50 C80 50, 85 55, 85 60 L85 75 C85 80, 80 85, 75 85 L25 85 C20 85, 15 80, 15 75 Z"
                className="fill-primary/10 stroke-primary"
                strokeWidth="3"
            />
            
            {/* The boleto paper sliding up */}
            <g className="animate-print">
                <g className="animate-float">
                    {/* Paper body */}
                    <path
                        d="M30 65 L70 65 L70 15 C70 12, 68 10, 65 10 L35 10 C32 10, 30 12, 30 15 Z"
                        className="fill-white stroke-primary shadow-sm"
                        strokeWidth="2.5"
                    />
                    <path
                        d="M30 65 L70 65"
                        className="stroke-primary"
                        strokeWidth="2.5"
                        strokeDasharray="4 4"
                    />
                    
                    {/* Barcode lines */}
                    <g className="animate-barcode stroke-primary">
                        <line x1="38" y1="20" x2="38" y2="40" strokeWidth="2.5" strokeLinecap="round" />
                        <line x1="43" y1="20" x2="43" y2="40" strokeWidth="1.5" strokeLinecap="round" />
                        <line x1="47" y1="20" x2="47" y2="40" strokeWidth="3" strokeLinecap="round" />
                        <line x1="53" y1="20" x2="53" y2="40" strokeWidth="1" strokeLinecap="round" />
                        <line x1="56" y1="20" x2="56" y2="40" strokeWidth="2.5" strokeLinecap="round" />
                        <line x1="62" y1="20" x2="62" y2="40" strokeWidth="1.5" strokeLinecap="round" />
                    </g>
                    {/* Bottom lines mimicking values */}
                    <line x1="38" y1="48" x2="52" y2="48" className="stroke-primary delay-700" strokeWidth="2" strokeLinecap="round" />
                    <line x1="38" y1="54" x2="62" y2="54" className="stroke-primary delay-1000" strokeWidth="2" strokeLinecap="round" />
                </g>
            </g>
            
            {/* Front slot to overlap paper */}
            <path
                d="M15 60 L85 60"
                className="stroke-primary"
                strokeWidth="3"
                strokeLinecap="round"
            />
            {/* Decorative LED / status dot */}
            <circle cx="50" cy="68" r="3" className="fill-primary" />
        </svg>
    );
};

export default AnimatedBoletoIcon;
